module.exports = __webpack_public_path__ + "static/door-outside-b965d7e460c564b7ebc7231b86a4d8fb.png";